export function createImageSizes(desktop: ImageSizesInput, mobile: ImageSizesInput): string;
export function createImageSizes(desktop: ImageSizesInput, tablet: ImageSizesInput, mobile: string | number): string;
export function createImageSizes(
    desktop: ImageSizesInput,
    tabletOrMobile?: ImageSizesInput,
    mobile?: ImageSizesInput
): string {
    let result = `(min-width: 1280px) ${toSize(desktop)}`;

    // has tablet
    if (mobile) {
        result += `, (min-width: 960px) ${toSize(tabletOrMobile!)}, ${toSize(mobile)}`;
    } else {
        result += `, ${toSize(tabletOrMobile!)}`;
    }

    return result;
}

function toSize(input: ImageSizesInput): string {
    if (typeof input === "number") {
        return `${input}px`;
    }
    return input;
}

export type ImageSizesInput = string | number;
